import { useQuery } from '@tanstack/react-query';
import { reportCommentsApi } from '@/api/report-comments';

export const REPORT_COMMENTS_QUERY_KEY = 'report-comments';

export function useReportComments(reportId?: string | null) {
    const query = useQuery({
        queryKey: [REPORT_COMMENTS_QUERY_KEY, reportId],
        queryFn: () => reportCommentsApi.list(reportId!),
        enabled: !!reportId,
        staleTime: 30 * 1000,
    });

    return {
        ...query,
        comments: query.data || [],
    };
}
